/**
 * When the app should call NOAA.
 *
 * The naive loop polls 18 stations every 6 minutes forever — about 4,300
 * requests a day per open tab, whether or not anyone is looking. A tab left open
 * overnight spends the night hammering a free public API for readings nobody
 * sees, and CO-OPS already answers bursts with 403s.
 *
 * So: never poll a hidden tab, and catch up on return rather than waiting out
 * the remainder of an interval that expired while the tab was in the background.
 */

/** A scheduled tick should be skipped entirely while the tab is hidden. */
export function shouldPoll(hidden: boolean): boolean {
  return !hidden;
}

/**
 * On becoming visible again, refetch only if what is on screen has actually
 * gone stale — switching tabs twice in a minute should not trigger two rounds.
 */
export function shouldCatchUp(
  lastRefresh: number,
  now: number,
  intervalMs: number,
): boolean {
  return now - lastRefresh >= intervalMs;
}
